import React, { useState } from "react"
import ClimateCheckLogo from "../../../ui/ClimateCheckLogo/ClimateCheckLogo"
import { Link } from "gatsby"
import Modal from "@components/Solutions/Modal"
import LearnMore from "@components/Solutions/LearnMore"

import CTARightArrow from "@images/img-min/ctaRightArrow.svg"
import Bars from "@images/img-min/bars.svg"
import Xmark from "@images/img-min/xmark.svg"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faBars, faTimes } from "@fortawesome/free-solid-svg-icons"

const CorporativeHeader = (inSolutions?) => {
  const [show, setShow] = useState(false)

  const handleOpen = () => {
    setShow(!show)
  }

  const [showModal, setShowModal] = useState(false)

  const toggleModal = () => {
    setShowModal(!showModal)
  }

  return (
    <div className="corporative-header">
      <div className="container">
        <ClimateCheckLogo color="green" />
        <div className={`corporative-header-menu ${show ? "display" : "hide"}`}>
          <Link className="corporative-header-menu-link" to="/about-us">
            About
          </Link>
          <Link className="corporative-header-menu-link" to="/blog">
            Blog
          </Link>
          <Link className="corporative-header-menu-link" to="/risks/overview">
            Risks
          </Link>
          <Link
            className="corporative-header-menu-link"
            to="/our-methodologies"
          >
            Methodologies
          </Link>
          <Link
            className="corporative-header-menu-link link-cta"
            to="/solutions"
            onClick={() => setShowModal(true)}
          >
            Get Enterprise Data
            <CTARightArrow />
          </Link>
        </div>
        {show ? (
          <Xmark className="navIcon no-visible" onClick={handleOpen} />
        ) : (
          <Bars className="navIcon no-visible" onClick={handleOpen} />
        )}
      </div>
      {showModal && inSolutions && (
        <Modal onClose={showModal} setOpen={() => setShowModal(!showModal)}>
          <LearnMore toggle={toggleModal} />
        </Modal>
      )}
    </div>
  )
}

export default CorporativeHeader
